<template>
  <div class="content_main">
    <div class="bgone" id="bgone">
      <div class="centerOne">
        <div class="head">
          <div class="firmlogo">
            <div class="firmlogoright">
              <img src="../../assets/img/logo1.svg" alt="" />
            </div>
            <!-- 调取本地邮箱测试用 -->
            <!-- <a href=mailto:sample@163.com>send email</a> -->
          </div>
          <div class="topright">
            <div class="selectleft" id="router">
              <!-- <a :class="{active: active===3}" @click="scrollTo(3)" href="javascript:void(0)"><span class="onespan"> Services </span></a>
                            <a :class="{active: active===4}" @click="scrollTo(4)" href="javascript:void(0)"><span class="onespan"> POD </span></a>
                            <a :class="{active: active===6}" @click="scrollTo(6);changeShow6()" href="javascript:void(0)"><span>Price</span></a>
                            <a :class="{active: active===6}" @click="scrollTo(6);changeShow8()" href="javascript:void(0)"><span> Delivery Time</span></a> -->
              <a @click="back" href="javascript:void(0)"><span>Home</span></a>
            </div>
            <div @click="contact_us" class="selectright">
              <div><span>Contact Us Now</span></div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="bgtwo">
      <div class="centertwo">
        <div class="bgtwo_title">About US</div>
        <!-- <transition name="bounce"> -->
        <div class="com_video" >
          <div class="video">
            <video
                ref="myVideo"
                width="100%"
                height="100%"
                muted="muted"
                controls
                :poster="this.poster"
            >
              <source
                  :src="this.video_url"
                  type="video/mp4"
              />
            </video>
          </div>
        </div>
        <!-- </transition> -->
        <div class="abous_us">
          <div v-html="this.dec"></div>
        </div>
      </div>
    </div>
    <div class="bgnine">
      <div class="centeNine">
        <div class="foot">
          <div class="footOne">
            <img src="../../assets/img/logo1.svg" alt="" />
            <div class="webfba">
              Webfba – 
We are the All-In-One Dropshipping agent who helps you source and ship anything you need, such as general cargo, liquid, sensitive cargo, what more, we also offer POD service, One-piece also can be customized.
            </div>
          </div>
          <div class="footTwo">
            <div class="footTwoTitle">What we offer</div>
            <div class="footTwoContent">
              <ul>
                <li class="about-us" @click="rot('services',3)">Services</li>
                <li @click="rot('services',4)">POD</li>
                <li @click="product">Product</li>
                <li @click="rot('services',6)">Price</li>
                <li  @click="rot('services',6)">Delivery</li>
                <li  @click="rot('services',6)">Time</li>
                <li  @click="rot('services',8)">Processing</li>
              </ul>
            </div>
          </div>
          <div class="footThree">
            <div class="footThreeTitle">Our Company</div>
            <div class="footThreeContent">
              <ul>
                <li @click="abous">About Us</li>
                <li  @click="rot('services',6)">Why Us？</li>
                <el-button
                  class="contact"
                  type="text"
                  @click="contact_us"
                  ><li class="contact_us">Contact Us</li></el-button
                >
              </ul>
            </div>
          </div>
          <div class="footFour">
            <!-- <div class="footFourTitle">Need help?</div>
            <div class="footFourContent">
              <ul>
                <el-button
                  class="contact"
                  type="text"
                  @click="centerDialogVisible = true"
                  ><li class="contact_us">Contact Us</li></el-button
                >

                <li>Help Center</li>
                <li>FAQs</li>
              </ul>
            </div> -->
            <!-- 点击底部contact us弹窗 邮箱链接-->
            <el-dialog
              title="Contact US"
              :visible.sync="centerDialogVisible"
              width="40%"
              center
            >
              <a
                href="https://mail.google.com/mail/u/0/?fs=1&tf=cm&source=mailto&to=support@webfba.com"
                style="float: left"
                ><div
                  style="
                    float: left;
                    display: inline;
                    font-size: 2.5rem;
                    line-height: 4rem;
                  "
                >
                  click:
                </div>
                <img
                  src="../../assets/img/logo_gmail.png"
                  alt=""
                  style="width: 10rem; height: 4rem; float: right"
              /></a>
              <span slot="footer" class="dialog-footer">
                <!-- <el-button @click="centerDialogVisible = false">取 消</el-button> -->
                <!-- <el-button type="primary" @click="centerDialogVisible = false">确 定</el-button> -->
              </span>
            </el-dialog>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Bus from '../../assets/js/bus';
export default {
  name: "Abous_us",
  data() {
    return {
      centerDialogVisible: false,
      video_url:'',
      dec:'',
      poster:''
    };
  },
  created() {
    this.http
        .fetchGet(this.api.about, {id:1})
        .then((res) => {
          if(res.data.code == 200){
            this.video_url = res.data.data.video_url;
            this.dec = res.data.data.description;
            this.poster = res.data.data.poster;
            this.$nextTick(() => {
              this.$refs.myVideo.load();
              this.$refs.myVideo.play();
            })
          }
        })
        .catch((err) => {
          console.log(err);
        });
  },
  methods: {
    abous() {
      this.$router.push({ path: "/Abous_us" });
    },
    product() {
      this.$router.push({ path: "/products" });
    },
    contact_us() {
      this.$router.push({ path: "/contact_us" });
    },
    rot(event,index){
      this.back();
      Bus.$emit(event,index);
      
    },
    back() {
      this.$router.go(-1);
      //  this.$router.push({ path: "./" });返回主页顶部
    },
  },
};
</script>
<style>

.abous_us p {
  font-size: 20px;
  line-height: 40px;
  color: #888;
}

.abous_us .top-line {
  margin-top: 4rem;
}

.abous_us .line {
  border: 2px red solid;
  width: 3.5rem;
}

.abous_us .abous_title {
  font-size: 21px;
  font-weight: bold;
  color: black;
}
</style>
<style lang='stylus' scoped>
.content_main .bgtwo .centertwo .abous_us p{
  color:black!important;
}
.content_main {
  width: 100%;
  height: 100%;
  font-size: 62.5%;
  min-width: 127rem;

  .bgone {
    width: 100%;
    height: 10rem;
    position: fixed;
    top: 0px;
    z-index: 9999;
    // backdrop-filter: saturate(180%) blur(6px);
    background-color: rgba(7, 17, 27, 0.5);
    // filter: opacity(.3);
    background-color: var(--header-background);
    background-color: #FFFFFF;
    box-shadow: 3rem 0px 4rem #EEE;

    // background-image: linear-gradient(#ff7300, #FFFF);
    .centerOne {
      width: 120rem;
      margin: 0 auto;

      // background-color: greenyellow;
      .head {
        .firmlogo {
          float: left;
          width: 30.2rem;
          height: 8.1rem;
          margin-top: 1rem;

          .firmlogoright {
            float: left;
            width: 26.1rem;
            height: 8.1rem;
            margin-left: -4rem;

            img {
              width: 100%;
              height: 100%;
            }
          }
        }

        .topright {
          float: right;
          margin-top: 3.1rem;

          .selectleft {
            width: 6 0rem;
            float: left;

            span {
              display: inline-block;
              font-size: 1.6rem;
              color: #333333;
              margin-left: 4rem;
              font-weight: bold;
              line-height: 4rem;
            }

            // .onespan {
            // margin-left: 0;
            // }
            span:hover {
              color: #FF7300;
            }
          }

          .selectright {
            float: right;
            // margin-top:0.5rem;
            background-color: #FF7300;
            border-radius: 0.2rem;
            margin-left: 4rem;
            width: 14rem;
            height: 4rem;
            font-weight: 10rem;

            div {
              text-decoration: none;

              span {
                display: block;
                color: #FFFFFF;
                font-size: 1.6rem;
                text-align: center;
                font-weight: bold;
                line-height: 4rem;
              }
            }

            span:hover {
              color: #333333;
            }
          }
        }
      }
    }
  }

  .bgtwo {
    margin-top: 20rem;

    .centertwo {
      width: 90rem;
      margin: 0 auto;

      .bgtwo_title {
        font-size: 30px;
        font-weight: 900;
        text-align: center;
        margin-bottom: 10px;
      }

      .abous_us {
        p {
          font-size: 20px;
          line-height: 40px;
          color: #888;
        }

        .top-line {
          margin-top: 4rem;

          .line {
            border: 2px red solid;
            width: 3.5rem;
          }

          .abous_title {
            font-size: 21px;
            font-weight: bold;
            color: black;
          }
        }
      }
    }
  }

  .bgnine {
    float: left;
    width: 100%;
    height: 35rem;
    background-color: #18252D;
    margin-top: 9.4rem;

    .centeNine {
      width: 120rem;
      margin: 0 auto;

      .foot {
        .footOne {
          width: 40rem;
          // height: 5.2rem;
          float: left;
          margin-top: 6rem;

          img {
            width: 30%;
          }

          .webfba {
            color: #FFFFFF;
            font-size: 1.4rem;
            line-height: 3rem;
            font-weight: bold;
            display: inline-block;
          }
        }

        .footTwo {
          widows: 100%;
          width: 13rem;
          float: left;
          margin-top: 6.7rem;
          margin-left: 20rem;

          .footTwoTitle {
            font-size: 1.8rem;
            color: #FF7300;
            font-weight: bold;
            float: left;
          }

          .footTwoContent {
            ul {
              margin: 0;
              padding: 0;

              li {
                widows: 100%;
                list-style: none;
                font-size: 1.4rem;
                color: #FFFFFF;
                line-height: 3rem;
                font-weight: bold;
                // display: inline-block;

                // a {
                //   color: #FFFFFF;
                // }

                // a:hover {
                //   color: #FF7300;
                // }
              }
              li:hover{
                  color: #FF7300;
                  cursor:pointer;
              }
            }
          }
        }

        .footThree {
          width: 20rem;
          float: left;
          margin-top: 6.7rem;
          margin-left: 25rem;

          .footThreeTitle {
            font-size: 1.8rem;
            color: #FF7300;
            font-weight: bold;
            float: left;
            width: 100%;
          }

          .footThreeContent {
            ul {
              margin: 0;
              padding: 0;

              li {
                width: 100%;
                list-style: none;
                font-size: 1.4rem;
                color: #FFFFFF;
                line-height: 3rem;
                font-weight: bold;
                display: inline-block;
              }
              li:hover{
                  color: #FF7300;
                  cursor:pointer;
              }
              .contact{
                  padding:0;
              }
            }
          }
        }

        .footFour {
          width: 10rem;
          float: right;
          margin-top: 6.7rem;

          .footFourTitle {
            font-size: 1.8rem;
            color: #FF7300;
            font-weight: bold;
            float: left;
            widows: 100%;
          }

          .footFourContent {
            ul {
              margin: 0;
              padding: 0;

              li {
                widows: 100%;
                list-style: none;
                font-size: 1.4rem;
                color: #FFFFFF;
                line-height: 3rem;
                font-weight: bold;
                display: inline-block;
              }

              .contact {
                padding: 0;
              }

              .contact_us:hover {
                color: #FF7300;
              }
            }
          }
        }
      }
    }
  }
}
</style>